// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2oVid","content":"GlobalSearch_content__Z6m0B"};